/* eslint-disable max-lines */
import {
  createNewFilter,
  createNewGroup,
  addFilterToMap,
  addGroupToMap,
  addFilterToItem, // new API
  addFilterToMainItem, // new API
  findItemFilterById, // new API
  removeFilterItem, // new API
  addGroupFilterToItem, // new API
  unGroupFilterToItem, // new API
  changeFilterItem, // new API
  changeGroupOperator, // new API
} from './actions.js';
import QueryBuilderFormat from '../format/format.js';
/**
 * Fluent interface: https://en.wikipedia.org/wiki/Fluent_interface
 * @param idGroup
 * @param parentIdGroup
 * @param items
 * @param idFilter
 * @param value
 * @param data
 * @class QueryBuilderStore
 */
class QueryBuilderStore {
  items = [];

  step = 0;

  steps = {};

  mapFilters = {};

  mapGroups = {};

  main = null;

  format = null;

  constructor(init, format) {
    this.firstLoad = true;
    this.format = format;
    if (init) return this.initSetupUp(init);
    const mainGroup = this.createNewGroup('main');
    this.mapGroups = {
      [mainGroup.idGroup]: mainGroup,
    };
    this.main = mainGroup.idGroup;
    this.addFilter(mainGroup.idGroup);

    this.initSetupUp = this.initSetupUp.bind(this);
  }

  initSetupUp(init) {
    this.step = init.step || 1;
    Object.keys(init).forEach((key) => {
      if (init[key] && this[key] !== undefined) this[key] = init[key];
    });
  }

  createNewFilter = (idGroup) => createNewFilter.call(this, idGroup);

  createNewGroup = (parentIdGroup) => createNewGroup.call(this, parentIdGroup);

  onOrderDragAndDrop = (items) => {
    this.items = items;
    return this.getState();
  };

  // eslint-disable-next-line no-unused-vars
  addFilterNextToFilterId = (idGroup, idFilter) => {
    // eslint-disable-line
    this.addFilter(idGroup);
    return this.getState();
  };

  addFilter = (idGroup) => {
    const newFilter = this.createNewFilter(idGroup);
    addFilterToMap.call(this, newFilter);
    // new API
    if (this.main === idGroup) {
      addFilterToMainItem.call(this, this.items, newFilter);
    } else {
      const foundInItems = findItemFilterById.call(this, idGroup);
      if (foundInItems) {
        addFilterToItem.call(this, foundInItems, newFilter);
      }
    }
    return this.getState();
  };

  onRemoveFilter = (idFilter) => {
    // new API
    removeFilterItem.call(this, idFilter);
    return this.getState();
  };

  addRuleContainerInPlace = (idGroup, idFilter) => {
    // Create a new group
    const newGroup = this.createNewGroup(idGroup);
    addGroupFilterToItem.call(this, idGroup, idFilter, newGroup);
    return this.getState();
  };

  /**
   * Group a filter inside a new Group
   * @param idGroup
   * @param idFilter
   */
  // eslint-disable-next-line no-unused-vars
  addRuleContainer = (idGroup, idFilter) => {
    // eslint-disable-line
    const newGroup = this.createNewGroup(idGroup);
    addGroupToMap.call(this, newGroup);
    if (this.main === idGroup) {
      addFilterToMainItem.call(this, this.items, newGroup);
    } else {
      const foundInItems = findItemFilterById.call(this, idGroup);
      if (foundInItems) {
        addFilterToItem.call(this, foundInItems, newGroup);
      }
    }
    return this.getState();
  };

  unGroup = (idGroup) => {
    unGroupFilterToItem.call(this, idGroup);
    return this.getState();
  };

  changeGroupOperator = (idGroup, value) => {
    this.getGroupById(idGroup).condition = value;
    changeGroupOperator.call(this, idGroup, value);
    return this.getState();
  };

  changeFilter = (data) => {
    const { idFilter } = data;
    this.mapFilters[idFilter] = {
      ...this.mapFilters[idFilter],
      ...data,
    };
    changeFilterItem.call(this, data);
    return this.getState();
  };

  getGroupById = (idGroup) => this.mapGroups[idGroup] || {};

  getFilterById = (idFilter) => this.mapFilters[idFilter];

  getInitialState = () => {
    const newFilters = {
      step: this.step,
      mapFilters: { ...this.mapFilters },
      mapGroups: { ...this.mapGroups },
      main: this.main,
      items: this.items,
    };
    const format = QueryBuilderFormat.run(newFilters, this.format);
    return {
      ...newFilters,
      format,
    };
  };

  getState = () => {
    this.step += 1;
    const newFilters = {
      step: this.step,
      mapFilters: { ...this.mapFilters },
      mapGroups: { ...this.mapGroups },
      main: this.main,
      items: this.items,
    };
    const format = QueryBuilderFormat.run(newFilters, this.format);
    return {
      ...newFilters,
      format,
    };
  };
}

export default QueryBuilderStore;
